export const styles = theme => ({
  containerLauncher: {
    position: 'relative',
    height: '60px',
    width: '60px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '30px',
    margin: '10px',
    cursor: 'pointer',
    userSelect: 'none',
    '&:first-child': {
      transition: '0.4s all',
    },
    '@media (hover: none)': {
      cursor: 'default',
    },
  },
  logo: {
    width: '22px',
    animationDuration: '.4s',
    animationName: 'appear',
  },
  xIcon: {
    animationDuration: '.4s',
    animationName: 'appearIn',
  },
})

export const setWidgetColor = color => ({
  backgroundColor: color,
})
